<template>
  <div :style="style" class="data-container">
    <div class="title">{{generateTitle()}}    
    </div>
    <div class="data" :style="data_style">{{ $t('message.current_value') }}
    </div>
    <div class="info">{{ $t('message.update_message') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldComponent',
  data(){
    return {
      style:'',
      data_style:'',
    /////////////
      TYPE_RADIO:1,
      TYPE_TEXT:2,
      TYPE_OTHER:3
    }
  },
  props: {
    component: null
  },
  methods:{
    generateTitle(){

      let fd=this.component.data.data;
      
      if(fd.field.key=='sessionkey')
        return this.$t('message.serial_number');

      let components;

      let pages=JSON.parse(this.$common.qr.qrjson).pages;

      for(var i=0; i<pages.length;i++){

        if(pages[i].key==fd.formkey){

          components=pages[i].components;

          for(var j=0; j<components.length;j++){

            if(components[j].key==fd.field.key){

              return components[j].data.data.title.replace(/(<([^>]+)>)/gi, "");

            }

          }

        }

      }

      return "";

    },
    generateDataStyle(){

      let Fd=this.component.data.data;
    
      const type=this.componentType(Fd);

      if(type==this.TYPE_TEXT)
        return 'color:'+Fd.field.style.color+';font-size:'+Fd.field.style.font_size+'px;font-weight:'+Fd.field.style.font_weight;
      else if(type==this.TYPE_RADIO)
        return 'color:'+Fd.field.radio_styles[0].style.color+';font-size:'+Fd.field.radio_styles[0].style.font_size+'px;font-weight:'+Fd.field.radio_styles[0].style.font_weight;
      else
        return 'color:grey;font-size:30px;font-weight:800';

    },
    componentType(fd){

      if(fd.field.key=='sessionkey')
        return this.TYPE_TEXT;

      let controltypes=[
                                this.$common.FORM_CONTROL_INPUT, // 单文本输入
                                this.$common.FORM_CONTROL_MULTILINE_INPUT, // 多文本输入
                                this.$common.FORM_CONTROL_NUMERIC_INPUT, // 数字输入
                                this.$common.FORM_CONTROL_DATE_INPUT, // 日期输入
                                this.$common.FORM_CONTROL_TIME_INPUT, // 时间输入
                                //this.$common.FORM_CONTROL_RADIO_INPUT, // 单选输入
                                this.$common.FORM_CONTROL_CHECKBOX_INPUT, // 多选输入
                                this.$common.FORM_CONTROL_CHECKLIST_INPUT, // 检查项
                                this.$common.FORM_CONTROL_LOCATION_INPUT, // 定位
                                this.$common.FORM_CONTROL_ADDRESS_INPUT, // 定制
                                this.$common.FORM_CONTROL_SIGNATURE_INPUT, // 签名
                                this.$common.FORM_CONTROL_PICS_INPUT, // 上传图片
                                this.$common.FORM_CONTROL_WECHAT_INPUT, // 微信名
                                this.$common.FORM_CONTROL_ID_INPUT, // 身份证号
                                this.$common.FORM_CONTROL_MOBILE_INPUT, // 手机号码
                                this.$common.FORM_CONTROL_CHEPAI_INPUT, // 车牌
                                this.$common.FORM_CONTROL_VIDEO_INPUT, // 录像
                                this.$common.FORM_CONTROL_FILE_INPUT, // 文件上传
                                this.$common.FORM_CONTROL_GENDER_INPUT, // 性别输入
                                this.$common.FORM_CONTROL_GONGHAO_INPUT, // 工号输入
                                this.$common.FORM_CONTROL_AUDIO_INPUT, // 录音输入
                                this.$common.FORM_CONTROL_TABLE_INPUT, // 表格输入
                                this.$common.FORM_CONTROL_DUOJI_INPUT, // 多级输入
                                this.$common.FORM_CONTROL_NAME_INPUT
      ]

      let components;

      let pages=JSON.parse(this.$common.qr.qrjson).pages;

      let found=false;

      for(var i=0; i<pages.length;i++){

        if(pages[i].key==fd.formkey){

          components=pages[i].components;

          found=true;

          break;

        }

      }

      if(!found)
        return this.TYPE_OTHER;

      for(var j=0; j<components.length;j++){

        if(components[j].key==fd.field.key){

          if(components[j].type==this.$common.FORM_CONTROL_RADIO_INPUT||components[j].type==this.$common.FORM_CONTROL_GENDER_INPUT)
            return this.TYPE_RADIO;
          else if(controltypes.includes(components[j].type))
            return this.TYPE_TEXT;
          else
            return this.TYPE_OTHER;

        }

      }

      return this.TYPE_OTHER;

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.component.data.style);

    this.data_style=this.generateDataStyle();

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .data-container{
        box-shadow: 0 0.256rem 0.59733rem rgb(0 0 0 / 7%);
        border-radius: 8px !important;
        padding:10px; 
        background-color:white;   
    }
    .title{
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        color: #333;
        word-break: break-word;
    }
    .data{
        margin: 20px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    } 
    .info{
        font-size: small;
        color: rgba(0, 0, 0, 0.45);
        text-align: center;
    }
</style>
